import DynamicInput from './DynamicInput'

export default DynamicInput
